'use client';

import React, { useState } from 'react';
import MerchantFaqsAccordion from './MerchantFaqsAccordion';
import { Faqs } from '@/services/dataTypes';

interface Props {
    faqs: Faqs[];
}

const INITIAL_COUNT = 8;

const HomepageFAQsGrid = ({ faqs }: Props) => {
    const [showAll, setShowAll] = useState(false);

    const visibleFaqs = showAll ? faqs : faqs.slice(0, INITIAL_COUNT);
    const hasMore = faqs.length > INITIAL_COUNT;

    return (
        <>
            {/* 2-column accordion grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5">
                {visibleFaqs.map((faq, idx) => (
                    <MerchantFaqsAccordion key={idx} faq={faq} index={idx} />
                ))}
            </div>

            {/* Show More / Show Less toggle */}
            {hasMore && (
                <div className="flex justify-center mt-8">
                    <button
                        onClick={() => setShowAll(prev => !prev)}
                        className="group flex items-center gap-2 px-6 py-3 rounded-xl border border-[#D61C4E]/20 bg-[#D61C4E]/5 hover:bg-[#D61C4E] transition-all duration-300"
                    >
                        <span className="text-[11px] font-black uppercase tracking-[0.2em] text-[#D61C4E] group-hover:text-white transition-colors">
                            {showAll ? 'Show Less' : `Show More`}
                        </span>
                        <span className="w-5 h-5 rounded-full bg-[#D61C4E]/10 group-hover:bg-white/20 flex items-center justify-center transition-colors">
                            <svg
                                className={`w-2.5 h-2.5 text-[#D61C4E] group-hover:text-white transition-all duration-300 ${showAll ? 'rotate-180' : ''}`}
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={3}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                            </svg>
                        </span>
                    </button>
                </div>
            )}
        </>
    );
};

export default HomepageFAQsGrid;
